import React from "react";
import arrow from "src/assets/images/arrow-left.svg";
import { translate } from "src/services/translation.service";
import { media } from "src/theme";
import styled from "styled-components";

import { ISliderSettings } from "../Slider/Slider.component";

export const DEFAULT_SLIDES_TO_SHOW = 4;
export const MAX_SLIDES_TO_SHOW = 6;
export const PREV_NEXT_WIDTH_PERCENTAGE = 25;

const Arrow = styled.img`
  z-index: 1;

  && {
    width: ${PREV_NEXT_WIDTH_PERCENTAGE}%;
    height: 100%;
    padding: 0 9%;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;

    ${media.mobile} {
      width: 10px;
      height: 100%;
      padding: 0;
      opacity: 1;
    }
  }

  &:hover {
    opacity: 0.5;
  }
`;

const PrevBlock = styled(Arrow)`
  &.slick-prev {
    left: 0px;
  }
`;

const NextBlock = styled(Arrow)`
  &.slick-next {
    right: 0px;
    transform: translateY(-50%) rotate(180deg);
  }
`;

const PaginationSlider = styled.div`
  flex-grow: 1;
`;

export const defaultSettings: ISliderSettings = {
  arrows: true,
  autoplay: false,
  customPaging: (i: number): JSX.Element => (
    <PaginationSlider key={`pagination-slider-${i}`} />
  ),
  dots: true,
  infinite: true,
  nextArrow: <NextBlock src={arrow} alt={translate("global.previous")} />,
  prevArrow: <PrevBlock src={arrow} alt={translate("global.next")} />,
  swipeToSlide: true,
  slidesToShow: DEFAULT_SLIDES_TO_SHOW,
  responsive: [
    {
      breakpoint: 1120,
      settings: {
        slidesToShow: DEFAULT_SLIDES_TO_SHOW,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: DEFAULT_SLIDES_TO_SHOW,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: `${PREV_NEXT_WIDTH_PERCENTAGE}%`,
      },
    },
  ],
};
